import React from "react";

export const DocReplacementSvg = (props) => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 10.8 14.3"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.9 4.9v8.5a1.8 1.8 0 01-1.8 1.8v-.9a.9.9 0 00.9-.9V4.9h-1.8a1.3 1.3 0 01-1.3-1.4V1.7H5a.9.9 0 00-.9.9v8.1h-.9V2.6A1.8 1.8 0 015 .8h4.9z"
        transform="translate(-3.2 -.8)"
      ></path>
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.1"
        d="M5.8 8.7a.5.5 0 01.5-.5M7.4 8.2a.6.6 0 01.6.5M8 9.8a.6.6 0 01-.6.6M6.3 10.4a.6.6 0 01-.5-.6M2.8 9.5l.8.9.8-.9"
      ></path>
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.1"
        d="M3.6 10.4V9a.8.8 0 01.8-.8h.3"
      ></path>
      <rect
        width="2.2"
        height="2.2"
        x="2.5"
        y="11.4"
        fill="currentColor"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.1"
        rx="0.6"
        ry="0.6"
      ></rect>
    </svg>
  );
}
